import { jsPDF } from 'jspdf';
import { INTERVALS, KIND_LABEL, fmtDate, fmtDateTime } from './partnerPlanApi';

// jsPDF's built-in fonts have no ₹ glyph, so amounts use "Rs."
const rs = (minor) => `Rs. ${(Number(minor || 0) / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export const downloadReceipt = ({ payment, billedTo }) => {
  const doc = new jsPDF({ unit: 'pt', format: 'a4' });
  const W = doc.internal.pageSize.getWidth();
  const M = 48;
  let y = 56;

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(20);
  doc.text('RestroPilots', M, y);
  doc.setFontSize(11);
  doc.setFont('helvetica', 'normal');
  doc.setTextColor(110);
  doc.text('Payment receipt', W - M, y, { align: 'right' });

  y += 34;
  doc.setDrawColor(220);
  doc.line(M, y, W - M, y);

  y += 28;
  doc.setTextColor(30);
  const meta = [
    ['Receipt no.', payment.receiptNumber || '—'],
    ['Order ID', payment.orderId],
    ['Paid on', fmtDateTime(payment.paidAt)],
    ['Payment method', (payment.paymentMethod || '—').toUpperCase()],
    ['Bank reference', payment.bankReference || '—'],
  ];
  doc.setFontSize(10);
  meta.forEach(([k, v], i) => {
    doc.setTextColor(120); doc.text(k, M, y + i * 16);
    doc.setTextColor(30);  doc.text(String(v), M + 110, y + i * 16);
  });

  doc.setTextColor(120); doc.text('Billed to', W / 2 + 20, y);
  doc.setTextColor(30);
  [billedTo?.name, billedTo?.email, billedTo?.phone].filter(Boolean).forEach((line, i) => doc.text(String(line), W / 2 + 20, y + 16 + i * 16));

  y += meta.length * 16 + 30;
  doc.setFillColor(246, 243, 232);
  doc.rect(M, y, W - 2 * M, 26, 'F');
  doc.setFont('helvetica', 'bold');
  doc.text('Description', M + 12, y + 17);
  doc.text('Amount', W - M - 12, y + 17, { align: 'right' });
  doc.setFont('helvetica', 'normal');

  const q = payment.quote || {};
  const rows = [
    [`${payment.planName} plan — ${INTERVALS[payment.interval]?.label || payment.interval} (${KIND_LABEL[payment.kind] || payment.kind})`, rs(q.baseMinor)],
    [`Service period: ${fmtDate(q.periodStart)} – ${fmtDate(q.periodEnd)}`, ''],
  ];
  if (q.setupFeeMinor) rows.push(['One-time setup fee', rs(q.setupFeeMinor)]);
  if (q.discountMinor) rows.push(['Discount', `- ${rs(q.discountMinor)}`]);
  if (q.prorationCreditMinor) rows.push(['Credit for unused time on previous plan', `- ${rs(q.prorationCreditMinor)}`]);
  rows.push(['Taxable value', rs(q.taxableMinor)]);
  rows.push([q.taxMode === 'inclusive' ? `GST included (${q.gstRatePercent}%)` : `GST (${q.gstRatePercent}%)`, rs(q.taxMinor)]);

  y += 26;
  rows.forEach(([d, a]) => {
    y += 22;
    doc.setTextColor(d.startsWith('Service period') ? 120 : 30);
    doc.text(doc.splitTextToSize(d, W - 2 * M - 140), M + 12, y);
    if (a) doc.text(a, W - M - 12, y, { align: 'right' });
  });

  y += 18;
  doc.setDrawColor(220);
  doc.line(M, y, W - M, y);
  y += 24;
  doc.setFont('helvetica', 'bold');
  doc.setFontSize(12);
  doc.setTextColor(30);
  doc.text('Total paid', M + 12, y);
  doc.text(rs(payment.status === 'fulfilled' ? q.totalMinor : 0), W - M - 12, y, { align: 'right' });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(9);
  doc.setTextColor(130);
  doc.text('This is a computer-generated payment receipt and does not require a signature.', M, doc.internal.pageSize.getHeight() - 48);

  doc.save(`RestroPilots-receipt-${payment.receiptNumber || payment.orderId}.pdf`);
};
